import { render, staticRenderFns } from "./CPU.vue?vue&type=template&id=67d9f856&"
import script from "./CPU.vue?vue&type=script&lang=js&"
export * from "./CPU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports